import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { v4 } from "uuid";
import {
  Grid,
  Select,
  Input,
  MenuItem,
  Checkbox,
  ListItemText,
  FormControl,
  Button,
} from "@material-ui/core";
import {
  Close as TimesCircle,
  KeyboardArrowDown as AngleDown,
  KeyboardArrowUp as AngleUp,
} from "@material-ui/icons";
import useStyles from "./styles";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const MultipleSelect = ({
  list,
  placeholder,
  onChange,
  initValues,
  multiple,
  resetOption = true,
  selectActiveType = "primary",
  ...rest
}) => {
  const [values, setValues] = useState(multiple ? [] : "");
  const [opened, setOpened] = useState(false);
  const styles = useStyles({ activeType: selectActiveType })();

  useEffect(() => {
    setValues(initValues);
  }, [initValues]);
  const handleClose = () => {
    setOpened(false);
  };

  const handleOpen = () => {
    setOpened(true);
  };

  const reset = (e) => {
    e.stopPropagation();
    setValues(multiple ? [] : "");
    onChange({ target: { value: [] } });
  };

  const labelId = v4();

  const getButtonName = () => list.find((item) => item.value === values)?.name;

  const getParsedButtonName = () => {
    const name = getButtonName();
    return name?.length > 20 ? `${name.substring(0, 17)}...` : name;
  };

  return (
    <Grid container item>
      <Button
        onClick={handleOpen}
        variant="outlined"
        className={`capitalize ${styles.button} ${
          values.length > 0 ? "active" : ""
        }`}
        title={!multiple ? getButtonName() : undefined}
      >
        {resetOption && values.length > 0 && (
          <TimesCircle className="reset" size={16} onClick={reset} />
        )}
        {!multiple && values !== "" ? getParsedButtonName() : placeholder}
        {opened ? <AngleUp size={16} /> : <AngleDown size={16} />}
      </Button>
      <FormControl>
        <Select
          className={styles.select}
          labelId={labelId}
          multiple={multiple}
          value={values}
          onChange={(event) => {
            setValues(event.target.value);
            onChange(event);
          }}
          open={opened}
          onClose={handleClose}
          displayEmpty
          input={<Input />}
          renderValue={() => placeholder}
          MenuProps={MenuProps}
          {...rest}
        >
          {list.map(({ value, name }) => (
            <MenuItem key={value} value={value}>
              {multiple && (
                <Checkbox
                  className={styles.checkbox}
                  checked={values.indexOf(value) > -1}
                />
              )}
              <ListItemText
                title={name}
                primary={
                  name?.length > 20 ? `${name?.substring(0, 17)}...` : name
                }
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};

MultipleSelect.defaultProps = {
  initValues: [],
  onChange: () => null,
  placeholder: "Select",
  list: [],
  multiple: true,
  resetOption: true,
  selectActiveType: "primary",
};

MultipleSelect.propTypes = {
  onChange: PropTypes.func,
  initValues: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  placeholder: PropTypes.string,
  list: PropTypes.array,
  multiple: PropTypes.bool,
  resetOption: PropTypes.bool,
  selectActiveType: PropTypes.string,
};

export default MultipleSelect;
